/**
 * The following scripts get applied on the frontend of your site.
 */
jQuery(document).ready(function($){

    $('.keyvisual').each(function(){
        $('button.pause-video').on('click', function(){
            $video = $(this).closest('.media').find('video');
            $icon = $(this).find('i.icon');
            $video.trigger($video.prop('paused') ? 'play' : 'pause');
            $icon.removeClass('icon-pause').removeClass('icon-play')
            $icon.addClass($video.prop('paused') ? 'icon-play' : 'icon-pause')
        })
    })
})